import React, { Component } from 'react';

export default class ScrollToTop extends Component {
  state = { intervalId: 0, isVisible: false };

  componentDidMount() {
    window.addEventListener('scroll', this.setVisibility);
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) clearInterval(this.state.intervalId);

    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  scrollToTop = () => {
    const intervalId = setInterval(this.scrollStep, this.props.delayInMs);
    this.setState({ intervalId });
  };

  setVisibility = () => {
    const { scrollY } = window;
    const { isVisible } = this.state;
    if (scrollY < 100) {
      this.setState({ isVisible: false });
    } else {
      if (!isVisible) this.setState({ isVisible: true });
    }
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setVisibility);
  }

  handleScrolling = () => this.scrollToTop();

  render() {
    const { isVisible } = this.state;

    return (
      isVisible && (
        <button title="Back to top" className="scroll-top" onClick={this.handleScrolling}>
          <span className="icon icon-hg-chev-up" />
        </button>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollToTop/ScrollToTop.jsx